module.exports = __webpack_public_path__ + "a00b3aa72a13e2b6f753268f07e99a01.ttf";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-LightItalic.ttf
// module id = 360
// module chunks = 0